import React, { useState, useEffect } from 'react';
import {
    Alert,
    Col,
    Container,
    Row,
    Table
} from 'react-bootstrap';
import '../../styles/MembersTable.css';
import Loading from '../utility/Loading';
import AddUserToRoleModal from './AddUserToRoleModal';
import RemoveUserFromRole from './RemoveUserFromRole';

export default function AdminRoles() {
    const [loading, setLoading] = useState(false);
    const [admins, setAdmins] = useState();
    const [adminsLoading, setAdminsLoading] = useState(true);
    const [users, setUsers] = useState();
    const [usersLoading, setUsersLoading] = useState(true);
    const [loggedInSfId, setLoggedInSfId] = useState();
    useEffect(() => {
        const initializeData = async () => {
            setLoading(true);
            const userString = sessionStorage.getItem("user");
            if (userString !== null) {
                var sfid = "";
                var user = {};
                try {
                    user = JSON.parse(userString);
                }
                catch (ex) {
                    console.log("JSONParseUser", ex);
                }
                sfid = user.sfid;
                
                // get admin users and such
                setLoggedInSfId(sfid);
                FetchAllUsers(sfid);
            }
            setLoading(false);
        }
        initializeData();
    }, []);

    async function FetchAllUsers (sfid) {
        const adminRes = await fetch('api/admin/getAdminUsers/' + sfid)
            .then(async (response) => {
                setAdminsLoading(false);
                if (response.status !== 200) {
                    return null;
                }
                try {
                    return await response.json()
                        .then(json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors);
                            return json.message;
                        });
                }
                catch (ex) {
                    console.log("adminRolesJson", ex);
                    return null;
                }
            })
            .catch(ex => {
                console.log("adminRolesResponse", ex);
                return null;
            });
        setAdmins(adminRes);

        const usersRes = await fetch('api/admin/getUsers/' + sfid)
            .then(async (response) => {
                setUsersLoading(false);
                if (response.status !== 200) {
                    return null;
                }
                try {
                    return await response.json()
                        .then(json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors);
                            return json.message;
                        });
                }
                catch (ex) {
                    console.log("usersRolesJson", ex);
                    return null;
                }
            })
            .catch(ex => {
                console.log("usersRolesResponse", ex);
                return null;
            });
        setUsers(usersRes);
    }

    const renderTable = (title, description, data, role) => {
        let hhieUsersProp = (role === 'Admin') ? (admins?[...admins]:[]) : (users?[...users]:[]);
        const setHhieUsers = (usr) => {
            if (role === 'Admin') {
                setAdmins(usr);
            }
            else {
                setUsers(usr);
            }
        };
        var tableTitle = (
            <>
                <Row>
                    <Col>
                        <Alert.Heading>{title}</Alert.Heading>
                    </Col>
                    <Col className="d-flex justify-content-end">
                        <AddUserToRoleModal
                            role={role}
                            hhieUsers={hhieUsersProp}
                            setHhieUsers={setHhieUsers}
                        />
                    </Col>
                </Row>
                {description}
            </>
        );
        var tableHeader = (<thead>
            <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th></th>
            </tr>
        </thead>
        );

        var tableBody = (
            <tbody>
                {data ?
                    data.map(hhieUser => {
                    var button = 
                        (loggedInSfId === hhieUser.id) 
                        ? <Alert variant="info" style={{ maxWidth: '100px', textAlign: 'center' }}><strong>Self</strong></Alert> 
                        : <RemoveUserFromRole 
                            role={role}
                            user={hhieUser}
                            hhieUsers={hhieUsersProp}
                            setHhieUsers={setHhieUsers} />;
                    return (
                        <tr key={hhieUser.id}>
                            <td>{hhieUser.firstName}</td>
                            <td>{hhieUser.lastName}</td>
                            <td>{hhieUser.email}</td>
                            <td>{button}</td>
                        </tr>
                    );
                })
                    :<></>}
            </tbody>
        );

        return (
            <Row>
                <Col style={{
                    borderStyle: 'solid'
                    , borderWidth: '2px'
                    , borderColor: '#dee2e6'
                    , borderRadius: '0.25rem'
                    , padding: '0px'
                    , margin: '7px'
                }}>
                    <Alert variant="info" style={{
                        borderStyle: 'hidden'
                        , borderRadius: '0px'
                    }}>
                        {tableTitle}
                    </Alert>
                    <Table
                        striped
                        bordered
                        hover
                        variant="light"
                    >
                        {tableHeader}
                        {tableBody}
                    </Table>
                </Col>
            </Row>
        );
    }

    return (
        <Container>
            
            {loading && <Loading message="Loading, please wait . . ." />}
            {!loading &&
                <>
                    <br />
                    <h2>Roles (Access Management)</h2>
                    {!adminsLoading && renderTable(
                        "HHIE Admin",
                        "HHIE Admins can take full advantage of the PASS/REG application.",
                        admins,
                        "Admin")
                    }
                    {!usersLoading && renderTable(
                        "HHIE Staff",
                        "HHIE Staff Members are unable to see or access the 'Admin' tab. They also have limited functionality in the application.",
                        users,
                        "Staff")
                    }
                </>
            }
        </Container>
    )
}